import { OrganizationDefaultContent } from '../models/OrganizationDefaultContent';
import { useFromContentful } from '../utils';

export const useContentfulOrganizationDefaultContent = () =>
    useFromContentful<OrganizationDefaultContent>('organizationDefaultContent');
